import * as jQuery from '../node_modules/jquery';
(<any>window).$ = (<any>window).jQuery = jQuery;

import { initCookieConsent } from './cookie-consent';

/* Custom imports */
import autosize from '../node_modules/autosize';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

var desktopWidth = window.matchMedia('(max-width: 1600px)');
var tabletWidth = window.matchMedia('(max-width: 1000px)');
var phoneWidth = window.matchMedia('(max-width: 650px)');

// Used for body scroll-lock when menu or contact module is open
var phoneWidthMenu = window.matchMedia('(max-width: 720px)');

window.onload = function () {
  const bodyElement = document.querySelector('body');
  const navToggle = document.querySelector('.nav-toggle');
  const nav = document.querySelector('.site-header');
  const contactToggle = document.querySelectorAll('.contact-toggle');
  const contactClose = document.querySelector('.contact-close');
  const contactModule = document.querySelector('.contact-module');
  const $nav = $('.site-header');

  const cookieAccept = document.querySelector('#acceptCookies');

  initCookieConsent();

  // Select all link items as a typecast
  const navItems = Array.from(
    document.getElementsByClassName(
      'link-item'
    ) as HTMLCollectionOf<HTMLElement>
  );
  const referenceCases = Array.from(
    document.getElementsByClassName(
      'case-item'
    ) as HTMLCollectionOf<HTMLElement>
  );
  const services = Array.from(
    document.getElementsByClassName(
      'service-item'
    ) as HTMLCollectionOf<HTMLElement>
  );

  // Hero heading animation
  $('.hero-heading').css(
    'animation',
    'slideIn 1.5s cubic-bezier(0.215, 0.610, 0.355, 1) forwards'
  );

  // Reference case animation
  referenceCases.forEach((item, index) => {
    if (item.style.animation) {
      item.style.animation = '';
    } else {
      item.style.animation = `itemSlide 0.75s cubic-bezier(0.215, 0.610, 0.355, 1) forwards ${
        index / 5
      }s`;
    }
  });

  // Service item animation
  services.forEach((item, index) => {
    if (item.style.animation) {
      item.style.animation = '';
    } else {
      item.style.animation = `itemSlide 0.75s cubic-bezier(0.215, 0.610, 0.355, 1) forwards ${
        index / 10
      }s`;
    }
  });

  // Toggler for mobile nav
  navToggle.addEventListener('click', () => {
    navToggle.classList.toggle('nav-toggle--active');

    $('.main-navigation').scrollTop(0);

    if (
      nav.classList.contains(
        'site-header--transparent' && 'site-header--scrolled'
      )
    ) {
    } else if (nav.classList.contains('site-header--transparent')) {
      $nav.toggleClass('site-header--scrolled');
    }

    if (phoneWidthMenu.matches) {
      $('body').toggleClass('scroll-lock');
    }

    /* Animate link items in */
    navItems.forEach((item, index) => {
      if (item.style.animation) {
        item.style.animation = '';
      } else {
        item.style.animation = `navItemsFade 0.5s ease forwards ${
          index / 8 + 0.1
        }s`;
      }
    });
  });

  // Toggler for the contact module
  contactToggle.forEach((element) =>
    element.addEventListener('click', function () {
      contactModule.classList.toggle('contact-module--active');
      if (navToggle.classList.contains('nav-toggle--active')) {
        setTimeout(function () {
          navToggle.classList.toggle('nav-toggle--active');
          navItems.forEach((item, index) => {
            item.style.animation = '';
          });
        }, 500);
      }

      if (phoneWidthMenu.matches) {
        if (bodyElement.classList.contains('scroll-lock')) {
        } else {
          $('body').toggleClass('scroll-lock');
        }
      }
    })
  );

  // Toggle scroll-lock off on contact module close
  contactClose.addEventListener('click', () => {
    if (bodyElement.classList.contains('scroll-lock')) {
      $('body').toggleClass('scroll-lock');
    }
  });

  // Cookie toggle
  if (cookieAccept != null) {
    cookieAccept.addEventListener('click', () => {
      $('.cookie-information').toggleClass('accepted');
    });
  }

  // Autosize of textarea within forms
  autosize(document.querySelectorAll('textarea'));

  // Changing the navbar on scroll
  $(function () {
    $(document).scroll(function () {
      if (navToggle.classList.contains('nav-toggle--active')) {
        return false;
      } else {
        $nav.toggleClass(
          'site-header--scrolled',
          $(this).scrollTop() > $nav.height()
        );
      }
    });
  });

  // Onload closing bracket
};

/*@@@@@@@@@@@@@@@@@@@@
SERVICES SWIPER
@@@@@@@@@@@@@@@@@@@@@*/
if (document.getElementById('swiper-services') != null) {
  servicesSwiperFunction(phoneWidth, tabletWidth);
}

function servicesSwiperFunction(x, y) {
  var servicesWrapper = document.querySelector('.swiper-wrapper-services');
  var servicesWrapperChildren = servicesWrapper.children.length;

  var slides = 0;

  if (x.matches) {
    slides = 1;
  } else if (y.matches && servicesWrapperChildren > 1) {
    slides = 2;
  } else if (servicesWrapperChildren > 2) {
    slides = 3;
  } else {
    slides = servicesWrapperChildren;
  }

  // Slideshow settings, documentation on swiperjs.com/swiper-api
  const servicesSwiper = new Swiper('.swiper', {
    direction: 'horizontal',
    loop: true,
    grabCursor: true,

    slidesPerView: slides,
    spaceBetween: 30,

    speed: 400,

    autoplay: {
      delay: 3000,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next-unique',
      prevEl: '.swiper-button-prev-unique',
    },
  });

  $('.swiper').mouseenter(function () {
    servicesSwiper.autoplay.stop();
  });
  $('.swiper').mouseleave(function () {
    servicesSwiper.autoplay.start();
  });

  // Swiper close
}

/*@@@@@@@@@@@@@@@@@@@@
ABOUT US PAGE SWIPER
@@@@@@@@@@@@@@@@@@@@@*/
if (document.getElementById('swiper-about') !== null) {
  var desktopWidth = window.matchMedia('(max-width: 1600px)');
  var tabletWidth = window.matchMedia('(max-width: 1000px)');
  var phoneWidth = window.matchMedia('(max-width: 650px)');

  aboutSwiperFunction(phoneWidth, tabletWidth, desktopWidth);
}

function aboutSwiperFunction(x, y, z) {
  var aboutWrapper = document.querySelector('.swiper-wrapper-about');
  var aboutWrapperChildren = aboutWrapper.children.length;

  var slides = 0;

  if (x.matches) {
    slides = 1;
  } else if (y.matches && aboutWrapperChildren > 1) {
    slides = 2;
  } else if (z.matches && aboutWrapperChildren > 2) {
    slides = 3;
  } else if (aboutWrapperChildren > 4) {
    slides = 5;
  } else if (aboutWrapperChildren > 3) {
    slides = 4;
  } else {
    slides = aboutWrapperChildren;
  }

  // Slideshow settings, documentation on swiperjs.com/swiper-api
  const aboutSwiper = new Swiper('#swiper-about', {
    direction: 'horizontal',
    loop: true,

    slidesPerView: slides,

    speed: 2000,

    autoplay: {
      delay: 2000,
      pauseOnMouseEnter: false,
    },

    allowTouchMove: false,
  });
  // Swiper close
}

/*@@@@@@@@@@@@@@@@@@@@
CASE IMAGES BLOCK SWIPER
@@@@@@@@@@@@@@@@@@@@@*/
var imagesSlider = document.getElementsByClassName('swiper-images-slider');

if (imagesSlider != null) {
  for (var i = 0; i < imagesSlider.length; i++) {
    caseImagesSwiperFunction(imagesSlider[i]);
  }
}

function caseImagesSwiperFunction(element) {
  // Slideshow settings, documentation on swiperjs.com/swiper-api
  const imagesSlider = new Swiper(element, {
    direction: 'horizontal',
    loop: false,

    slidesPerView: 1,

    speed: 400,

    spaceBetween: 50,

    allowTouchMove: true,

    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      dynamicBullets: true,
    },
  });
  // Swiper close
}
